import { Link, useRouteError } from "react-router-dom";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import ErrorSvg from "./ErrorSvg.svg";

const Error = () => {
  const err = useRouteError();

  return (
    <>
      <Navbar />
      <div className="container text-center bg-danger bg-gradient rounded mt-5 p-5 shadow text-white mb-5">
        <div className="row align-items-center">
          {/* Left Section: Image */}
          <div className="col-md-6 col-12 mb-5 mb-md-0">
            <img
              src={ErrorSvg}
              className="img-fluid w-50"
              alt="Error Illustration"
            />
          </div>
          {/* Right Section: Error Messages */}
          <div className="col-md-6 col-12 mb-5">
            <h3 className="fw-bold">Error Code: {err.status}</h3>
            <p className="lead mb-4">
              {" "}
              Oops, looks like you’ve taken a wrong turn. Don’t worry, it
              happens to the best of us. Let’s get you back on track!
            </p>
            <p className="text-muted">{err.data}</p>
            <h3>
              Go to{" "}
              <Link
                to="/home"
                className="text-decoration-none text-dark bg-white rounded p-1 fw-bold"
              >
                HomePage
              </Link>
            </h3>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Error;
